export default __webpack_public_path__ + "static/media/005-wake up.a86f13e2.svg";